import React from "react";


const FiniatLogo = ({maxWidth='200px'})=>{
    return <img src={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/finiat-blue.png'}
                alt="IQ Graphic"
                style={{ maxWidth: maxWidth, height: 'auto' }}
    />
}

export default FiniatLogo;